export default __webpack_public_path__ + "d6dca551b4b96b4f3231f5c20cb0cae6.webp";